import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getBundleAvailability } from 'store/ProductDetails/bundles/selectors';

import ViewLayout from '../_ViewLayout';
import BundleContainer from '../../components/BundleContainer';

/**
 * Tariff Details View, extends page ViewLayout
 * adding buy mechanics
 */
const TariffView = ({ hasAvailableBundles }) => {
  return <ViewLayout extraChildren={hasAvailableBundles ? <BundleContainer /> : null} isTariff />;
};

TariffView.propTypes = {
  /** availability props */
  hasAvailableBundles: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  hasAvailableBundles: getBundleAvailability(state),
});

export default connect(mapStateToProps)(TariffView);
